<template>
  <v-container :class="'custom-container-large'">
    <!-- Tabs at the top -->
    <v-card flat class="grey lighten-2">
      <v-tabs 
        v-model="activeTab" 
        background-color="grey lighten-2"
        color="success"
        slider-color="success"
        class="custom-tabs"
      >
        <v-tab class="custom-tab">
          {{ $t('acl_map') }}
        </v-tab>
        <v-tab class="custom-tab">
          {{ $t('status_map') }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- Breadcrumbs below tabs -->
    <v-row class="row-container">
      <v-col class="align-center text-start">
        <Breadcrumbs :items="breadcrumbs" />
      </v-col>
    </v-row>

    <!-- Content below breadcrumbs -->
    <v-container class="table-container">
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <MapByAssignment :appTenantId="appTenantId" />
        </v-tab-item>
        
        <v-tab-item>
          <MapByStatus :appTenantId="appTenantId" />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/styles/container-width.scss';
</style>

<style scoped>
.container {
  padding: 0;
}

.table-container {
  margin-top: 10px;
}

.row-container {
  margin-top: 5px;
  padding: 0 10px 0 10px;
  min-height: 37px;
}

.align-center {
  align-self: center;
}

.custom-tabs ::v-deep .v-tab {
  color: black !important;
}

.custom-tabs ::v-deep .v-tab--active {
  color: #4caf50 !important;
}

.custom-tab {
  text-transform: uppercase;
  font-weight: 500;
}
</style>

<script>
import { mapGetters } from 'vuex'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import MapByAssignment from '@/components/job/MapByAssignment.vue'
import MapByStatus from '@/components/job/MapByStatus.vue'

export default {
  name: "ConfigurationMap",

  components: {
    Breadcrumbs,
    MapByAssignment,
    MapByStatus
  },

  computed: {
    ...mapGetters('app', [
      'getUserApplicationById'
    ]),

    breadcrumbs() {
      return [
        {
          text: this.$t('job_settings'),
          prependIcon: 'mdi-cog-outline',
          iconColor: 'primary',
          to: {
            name: "JobSettings",
            params: { appId: this.$route.params.appId }
          },
          disabled: false,
          exact: true,
          ripple: true,
        },
        {
          text: this.$t('acl_map'),
          prependIcon: 'mdi-sitemap-outline',
        },
      ]
    },

    appInstance() {
      return this.getUserApplicationById(this.$route.params.appId)
    },

    appConfig() {
      if (!this.appInstance || !this.appInstance.config) return {}
      return this.parseApplicationConfig(this.appInstance.config)
    },

    appTenantId() {
      return (
        this.appConfig.tenant_id ||
        this.appConfig.tenantId ||
        (this.appConfig.tenant && (this.appConfig.tenant.id || this.appConfig.tenant.tenant_id)) ||
        null
      )
    }
  },

  data() {
    return {
      activeTab: 0
    }
  },

  methods: {
    parseApplicationConfig(string) {
      try {
        return JSON.parse(string)
      } catch (e) {
        return {}
      }
    }
  }
}
</script>
